export class CalculatedDates {

  public dateFinDelaiInstruction: Date;

  public dateFinDelaiRetractation: Date;

}
